jQuery(document).ready(function($) {

	$('.js-splash').slick({
		autoplay: true,
		arrows: false,
		dots: false,
		pauseOnHover: false,
		fade: true,
		speed: 1000,
		autoplaySpeed: 4000
	});

	$('.js-postcarousel').slick({
		autoplay: false,
		arrows: true,
		dots: false,
		infinite: true,
  		slidesToShow: 2,
  		slidesToScroll: 1,
  		prevArrow:'<button class="slick-prev slick-arrow fas fa-chevron-left" aria-label="Prev" type="button"></button>',
      	nextArrow:'<button class="slick-next slick-arrow fas fa-chevron-right" aria-label="Next" type="button"></button>',
      	responsive: [{
		    breakpoint: 1200,
		    settings: {
		       	dots: true,
		       	arrows: false
		    }
		},{
		    breakpoint: 991,
		    settings: {
		       	slidesToShow: 1,
		       	dots: true,
		       	arrows: false
		    }
		}]
	});

	$('.js-iconcarousel').slick({
		autoplay: false,
		arrows: false,
		dots: false,
		slidesToShow: 6,
		slidesToScroll: 6,
      	responsive: [{
		    breakpoint: 1200,
		    settings: {
				dots: true,
				slidesToShow: 3,
				slidesToScroll: 3,
		    }
		},
		{
		    breakpoint: 768,
		    settings: {
				dots: true,
				slidesToShow: 1,
				slidesToScroll: 1,
		    }
		}]
	});

	$('.js-staffcarousel').slick({
		autoplay: false,
		arrows: true,
		dots: true,
		infinite: true,
  		slidesToShow: 3,
  		slidesToScroll: 1,
  		prevArrow:'<button class="slick-prev slick-arrow fas fa-chevron-left" aria-label="Prev" type="button"></button>',
      	nextArrow:'<button class="slick-next slick-arrow fas fa-chevron-right" aria-label="Next" type="button"></button>',
      	responsive: [{
		    breakpoint: 991,
		    settings: {
		       	slidesToShow: 2
		    }
		}, {
		    breakpoint: 767,
		    settings: {
		       	slidesToShow: 1
		    }
		}]
	});

	function carouselHeadingHeight() {
		if($(window).width() > 991) {
			var highest = 0;

			$('.js-postcarousel .featured-article__heading').each(function() {
				if($(this).height() > highest) {
					highest = $(this).height();
				}
			});

			$('.js-postcarousel .featured-article__heading').each(function() {
				$(this).height(highest);
			});
		}
	}

	$(window).load(function() {
		carouselHeadingHeight();
	});

	$(window).resize(function() {
		carouselHeadingHeight();
	});
 
});
